<template>
    <div class="share-btn" :class="[ type ? 'share-btn--' + type : '' ]">
        <a
        :href="href"
        target="_blank"
        rel="nofollow noopener noreferrer"
        >
            <i :class="icon"></i>
            <span class="share-btn__text"><slot /></span>
        </a>
    </div>
</template>

<script>
export default {
    name: 'ShareButton',

    props: {
        // [line | facebook | twitter | mail]
        type: {
            type: String,
            required: true
        },
        href: {
            type: String,
            required: true
        },
        icon: {
            type: String,
            required: false
        }
    },
}
</script>

<style lang="scss" scoped>
.share-btn {
    width: 160px;
    padding: 8px 10px;
    border-radius: 5px;
    font-weight: bold;
    display: inline-block;
    margin: 3px;

    & > a {
        text-decoration: none;
        color: white;
    }

    &__text {
        margin-left: 8px;
    }

    ///////////////////////////////
    // LINE
    &--line {
        background-color: #00b900;

        &:hover {
            background-color: #019e01;
        }
    }

    //////////////////////////////
    // FACEBOOK
    &--facebook {
        background-color: #3b5998;

        &:hover {
            background-color: #274992;
        }
    }

    //////////////////////////////
    // TWITTER
    &--twitter {
        background-color: #55acee;

        &:hover {
            background-color: #339ae9;
        }
    }

        //////////////////////////////
    // EMAIL
    &--email {
        background-color: grey;

        &:hover {
            background-color: rgb(104, 103, 103);
        }
    }
}

@media screen and (max-width: 600px) {
    .share-btn {
        width: 100%;
    }
}
</style>